import { SPECIFIC_REWARD_TYPES } from '../rewards.constants';

export const careerGoldRewardType = SPECIFIC_REWARD_TYPES.career.careerGold;
